import {combineReducers} from 'redux' 

import { persistReducer } from 'redux-persist' // (1)

// choose one of localStorage or sessionStorage :-

import storage from 'redux-persist/lib/storage' // (2)
// set localStorage as default

/*
import sessionStorage from 'redux-persist/lib/storage/session'
  to set sessionStorage as default
*/
import cardReducer from './cart/cart-reducer'
import directoryReducer from './directory/directory-reducer'
import shopDataReducer from './shop-data/shop-data-reducer'

const persistConfig = { // (3)
  key: 'root',
  storage, // adding the type of storage
  whitelist: ['cart'] // add any key you want
  // 'user' is handled by firebase , we don't need to make it here
}

const rootReducer = combineReducers({ // (4)
  cart: cardReducer ,
  directory: directoryReducer,
  shopData: shopDataReducer
}); // this what it wase written in export default below

export default persistReducer(persistConfig, rootReducer); //(5)